const FloatToFixed = (value) => {
    if (!value) return ''
    let newNumber = parseFloat(value).toFixed(2)
    return newNumber
}

export default FloatToFixed